module.exports = __webpack_public_path__ + "static/media/FortiRichNEWLogo.aa60abf5.png";